import { useEventListener } from '@vueuse/core';

export const useHorizontalShadowManager = (
    TargetElementContainerSelector: string,
    TargetElementSelector: string,
    leftShadowClass: string,
    rightShadowClass: string,
    disableBreakpoint?: number,
    permittedOverflow = 10,
) => {
    let isNavigationScrollEventAdded = false;

    const isLeftSideOverflowing = (targetContainer: HTMLElement, targetElement: HTMLElement) => {
        const hasScrolledLeft = !!targetElement.scrollLeft;

        if (hasScrolledLeft) {
            targetContainer.classList.add(leftShadowClass);
        } else {
            targetContainer.classList.remove(leftShadowClass);
        }
    };

    const isRightSideOverflowing = (targetContainer: HTMLElement, targetElement: HTMLElement) => {
        const ERROR_MARGIN = 1;
        const hasScrolledRight = targetElement.scrollLeft + targetElement.clientWidth + ERROR_MARGIN < targetElement.scrollWidth;

        if (hasScrolledRight) {
            targetContainer.classList.add(rightShadowClass);
        } else {
            targetContainer.classList.remove(rightShadowClass);
        }
    };

    const checkOverflowingSide = (targetContainer: HTMLElement, targetElement: HTMLElement) => {
        isLeftSideOverflowing(targetContainer, targetElement);
        isRightSideOverflowing(targetContainer, targetElement);
    };

    const addShadowManager = () => {
        if (disableBreakpoint && window.innerWidth > disableBreakpoint) {
            return;
        }

        const targetContainer = document.querySelector<HTMLElement>(TargetElementContainerSelector);
        const targetElement = document.querySelector<HTMLElement>(TargetElementSelector);

        if (!targetContainer || !targetContainer) {
            return;
        }

        const targetElementTrueWidth = targetElement.scrollWidth;
        const targetElementCurrentWidth = targetElement.offsetWidth;

        const isOverflowing = targetElementTrueWidth > targetElementCurrentWidth + permittedOverflow;

        if (isOverflowing) {
            checkOverflowingSide(targetContainer, targetElement);

            if (!isNavigationScrollEventAdded) {
                useEventListener(
                    targetElement,
                    'scroll',
                    () => checkOverflowingSide(targetContainer, targetElement),
                    { passive: true },
                );

                isNavigationScrollEventAdded = true;
            }
        }
    };

    useEventListener(
        window,
        'resize',
        addShadowManager,
        { passive: true },
    );
    addShadowManager();
};
